import type { CollectionItem } from "../api/types";
import { classifySearchQuery, normalizeSearchText } from "../search/search-query";

export function matchesCollectionSearch(item: CollectionItem, rawQuery: string): boolean {
  const classified = classifySearchQuery(rawQuery);
  if (classified.kind === "empty") {
    return true;
  }

  const release = item.release;
  if (classified.kind === "collector") {
    if (release.collectorNumber !== classified.collectorNumber) {
      return false;
    }
    if (classified.collectorTotal !== null) {
      return release.collectorTotal === classified.collectorTotal;
    }
    return true;
  }

  const haystack = [
    release.casting.name,
    release.seriesName ?? "",
    release.color ?? "",
    release.variation ?? "",
    release.packName ?? "",
    release.packCode ?? "",
  ]
    .map(normalizeSearchText)
    .join(" ");

  return haystack.includes(classified.normalized);
}
